const DOCUMENT = 'ADD_APPLICANT_TO_MY_TEAM_';

const actions = {
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  LOAD_TALENT_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_TALENT_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_TALENT_ERROR: DOCUMENT + 'LOAD_ERROR',
  SHOW_MODAL: DOCUMENT + 'SHOW_MODAL',
  CLOSE_MODAL: DOCUMENT + 'CLOSE_MODAL',
  ADD_TALENT_TO_MY_TEAM_REQUEST: DOCUMENT + 'ADD_TALENT_TO_MY_TEAM_REQUEST',
  ADD_TALENT_TO_MY_TEAM_SUCCESS: DOCUMENT + 'ADD_TALENT_TO_MY_TEAM_SUCCESS',
  ADD_TALENT_TO_MY_TEAM_ERROR: DOCUMENT + 'ADD_TALENT_TO_MY_TEAM_ERROR',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  loadTalentsRequest: data => ({
    type: actions.LOAD_TALENT_REQUEST,
    payload: data,
  }),

  loadTalentsSuccess: data => ({
    type: actions.LOAD_TALENT_SUCCESS,
    payload: data,
  }),

  loadTalentsError: () => ({
    type: actions.LOAD_TALENT_ERROR,
  }),

  addTalentToMyTeamRequest: data => ({
    type: actions.ADD_TALENT_TO_MY_TEAM_REQUEST,
    payload: data,
  }),

  addTalentToMyTeamSuccess: () => ({
    type: actions.ADD_TALENT_TO_MY_TEAM_SUCCESS,
  }),

  addTalentToMyTeamError: () => ({
    type: actions.ADD_TALENT_TO_MY_TEAM_ERROR,
  }),

  showModal: () => ({
    type: actions.SHOW_MODAL,
  }),

  closeModal: () => ({
    type: actions.CLOSE_MODAL,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
